/**
 * Represents the Project Class.
 * @author Philipp Kamin <philipp.kamin@ateam.de>
 * @constructor
 * @param {Object} params - Parameters for Project.
 * @param {number} params.id - The Project ID.
 * @param {string} params.name - name of Project.
 * @param {string} params.description - Project Description.
 * @param {string} params.color - Color referenz for client visual
 * @param {number} params.creatorId - User Id of the Project creator.

 */
class Project {
    constructor(params) {
        if(params.name == undefined) {
            throw new TypeError('property name not found');
        }    

        /** @private @const */
        this.id = params.id !== undefined ? params.id : null;
        this.name = params.name !== undefined ? params.name : null;
        this.description = params.description !== undefined ? params.description : null;
        this.color = params.color !== undefined ? params.color : null;

        
        /** @private @const */
        this.creatorId = params.creatorId !== undefined ? params.creatorId : null;

    }
}

exports.Project = Project;


// WEBPACK FOOTER //
// src/classes/project.class.js